// Material Imports
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";

// Import CSS
import "./ArchiveModal.css";
import LoadingSpinner from "components/LoadingSpinner";
import useArchiveModal from "./useArchiveModal";

const ArchiveModal = ({ setRowSelection }) => {
  const {
    processing,
    archiveModalOpen,
    selectedRowIds,
    closeArchiveModal,
    onConfirm,
  } = useArchiveModal(setRowSelection);

  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={archiveModalOpen}
        onClose={closeArchiveModal}
      >
        <div className="completed-modal__container">
          <Paper>
            <div className="completed-modal__wrapper">
              <Tooltip title="Close" placement="bottom">
                <div
                  onClick={closeArchiveModal}
                  className="completed-modal__close"
                >
                  <CloseIcon />
                </div>
              </Tooltip>
              <div className="completed-modal__text">
                {!processing && (
                  <div>
                    {selectedRowIds?.length === 1 && (
                      <div>Are you sure you want to archive this task?</div>
                    )}
                    {selectedRowIds?.length > 1 && (
                      <div>
                        Are you sure you want to archive these{" "}
                        {selectedRowIds?.length} tasks?
                      </div>
                    )}
                  </div>
                )}
                {processing && (
                  <div>
                    <div className="completed-modal__processing">
                      Archiving {selectedRowIds?.length}{" "}
                      {selectedRowIds?.length > 1 ? "tasks" : "task"}.
                    </div>
                    <div className="completed-modal__spinner">
                      <LoadingSpinner color="secondary" />
                    </div>
                  </div>
                )}
              </div>
              <div className="completed-modal__buttons">
                <Button
                  style={{ minWidth: "100px" }}
                  variant="contained"
                  color="secondary"
                  onClick={onConfirm}
                  disabled={processing}
                >
                  Archive
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={closeArchiveModal}
                  disabled={processing}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Paper>
        </div>
      </Modal>
    </div>
  );
};

export default ArchiveModal;
